import React from 'react';
import PropTypes from 'prop-types';

export class UserAvatar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getUserPicture = this.getUserPicture.bind(this);
  }

  static propTypes = {
    user: PropTypes.object,
    showName: PropTypes.bool
  };

  getUserPicture() {
    const { user } = this.props;
    if (user.picture) {
      return <img src={user.picture} alt="presentation" />;
    }
    return '';
  }

  render() {
    return <div className="user-avatar">{this.getUserPicture()}</div>;
  }
}
